var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3018_91712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1188 0.0761719C14.8988 1.2644 15.5592 2.25758 16.2612 3.32647C11.4329 6.05965 8.59106 9.95154 8.55986 15.6091C9.42048 15.6514 10.2213 15.6296 11.0039 15.7374C14.5413 16.2263 17.0126 18.1151 18.0358 21.4976C19.0277 24.7813 18.1658 27.7223 15.5072 29.9666C12.7772 32.2661 9.62978 32.5984 6.43432 31.0779C2.68764 29.2929 0.740195 26.0876 0.204583 22.1341C-0.965442 13.4893 2.99054 7.21451 9.92619 2.45006C11.2106 1.56723 12.6471 0.898692 14.1188 0.0761719Z",
    fill: "#5196FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6266 0L39.8133 3.31574C35.0149 6.05919 32.1431 9.92541 32.1353 15.5996C32.9972 15.6458 33.7967 15.633 34.5807 15.7408C38.1232 16.2284 40.5803 18.1429 41.6008 21.5151C42.5836 24.7487 41.7308 27.668 39.1308 29.902C36.4293 32.2271 33.291 32.5967 30.0748 31.1172C26.423 29.4362 24.4495 26.3694 23.8281 22.5519C22.4969 14.3858 25.8926 8.13024 32.3121 3.26955C33.9306 2.04411 35.7845 1.1215 37.6266 0Z",
    fill: "#5196FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3018_91712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/Quotes.87fc1164117572b1e7879e62fd8e8c87.svg";
export { ForwardRef as ReactComponent };